import React from 'react';
import './loader.css';

const UniversalLoader = () => {

    return (
        <div className="loading-wrapper flex flex-col items-center justify-center">

            <div className="dot-loader">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>

    );
};

export default UniversalLoader;